import { CONSTANT } from '@/store/constants';
import { HistoryCallType } from '@/store/pairs';
import useSWR from 'swr';

type HistoryLite = {
    time: number;
    value: number;
};

async function fetchHistoryOkx({
    symbol,
    time = '1m',
}: {
    symbol: string;
    time?: string;
}) {
    if (!symbol) {
        return [];
    }

    time = time.includes('m') ? time : time.toUpperCase();
    const instId = `${symbol.replace('USDT', '-USDT')}`;
    try {
        const res = await fetch(
            `https://www.okx.com/api/v5/market/candles?instId=${instId}&bar=${time}&limit=1000`
        );
        const data = await res.json();
        const formatted: HistoryLite[] = data.data.map((item: any) => ({
            time: Math.floor(item[0] / 1000), // time ở dạng milliseconds
            value: parseFloat(item[4]), // close price
        }));

        return formatted.sort((a, b) => a.time - b.time);
    } catch {
        throw new Error('fetchHistoryOkx');
    }
}

async function fetchHistoryBinance({
    symbol,
    time = '1s',
}: {
    symbol: string;
    time?: string;
}) {
    if (!symbol) {
        return [];
    }

    try {
        const res = await fetch(
            `https://api.binance.com/api/v3/klines?symbol=${symbol}&interval=${time}&limit=1000`
        );
        const data = await res.json();

        const formatted: HistoryLite[] = data.map((item: any) => ({
            time: Math.floor(item[0] / 1000),
            value: parseFloat(item[4]),
        }));
        return formatted;
    } catch {
        throw new Error('fetchHistoryBinance');
    }
}

type OHLC = {
    time: number;
    close: number;
    low: number;
    open: number;
    symbol: string;
    volume: number;
};

export async function fetchHistoryHoldStation({
    symbol,
    time = '1m',
}: {
    symbol: string;
    time?: string;
}) {
    if (!symbol) {
        return [];
    }

    try {
        const res = await fetch(
            `${
                CONSTANT.URL_HISTORY_HOLDSTATION
            }/${symbol}?timeframe=${time}&to=${Date.now() / 1000}`
        );
        const data: OHLC[] = await res.json();

        const formatted: HistoryLite[] = data.reverse().map((item) => ({
            time: item.time,
            value: item.close,
        }));

        return formatted;
    } catch {
        throw new Error('fetchHistoryHoldStation');
    }
}

async function fetchHistory({
    symbol,
    historyCall,
    time,
}: {
    symbol: string;
    historyCall: string;
    time?: string;
}) {
    try {
        if (historyCall === HistoryCallType.holdstation) {
            return await fetchHistoryHoldStation({ symbol, time });
        }
        if (historyCall === HistoryCallType.okx) {
            return await fetchHistoryOkx({ symbol, time });
        }
        return await fetchHistoryBinance({ symbol, time });
    } catch {
        return await fetchHistoryHoldStation({ symbol, time });
    }
}

export const useGetHistoryChartLite = (
    symbol: string,
    historyCall: string | undefined,
    time?: string
) => {
    return useSWR(
        { key: `useGetHistoryChartLite-${symbol}`, symbol, historyCall, time },
        fetchHistory,
        {
            revalidateOnFocus: false,
        }
    );
};
